import { usePurchaseFormState } from '@/entities/purchase-form';

export const useHasOnlyPersonalizationErrors = () => {
    const formState = usePurchaseFormState();
    const errors = Object.keys(formState.errors);
    return {
        hasOnlyPersonalizationErrors: errors.length === 1 && errors[0] === 'personalization',
    };
};
